module.exports = __webpack_public_path__ + "static/media/breath-times.52c3efaa.svg";